import Swal from "sweetalert2";
import api from "../../services/api";

export const exportAnexosAnuladas = async (fromDate, toDate) => {
  try {
    if (!fromDate || !toDate) {
      return Swal.fire("Atención", "Debes seleccionar un rango de fechas para exportar", "warning");
    }

    Swal.fire({
      title: "Generando CSV...",
      text: "Por favor espera",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const response = await api.post(
      "/invoices/export-anexos-anuladas",
      { from: fromDate, to: toDate },
      { responseType: "blob" }
    );

    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const fechaInicio = fromDate.replace(/-/g, "_");
    const fechaFin = toDate.replace(/-/g, "_");
    link.download = `anexo_anuladas_${fechaInicio}_al_${fechaFin}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    Swal.fire({ icon: "success", title: "¡Descarga Completa!", timer: 3000, showConfirmButton: false });
  } catch (error) {
    Swal.fire({ icon: "error", title: "Error", text: "No se pudo completar la exportación" });
  }
};